import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  	selector: '[appInputDecimal]'
})

export class InputDecimalDirective {
	private _decimalPlace: number = 3;
  	private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', '-', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];
  	@Input('appInputDecimal')
  	get decimalPlace(): any {
  		return this._decimalPlace;
	}
	set decimalPlace(value: any) {
  		this._decimalPlace = value || 3;
	}

  	constructor(private el: ElementRef) {
  	}

  	@HostListener('keydown', ['$event'])
  	onKeyDown(event: KeyboardEvent) {
	    const regex: RegExp = new RegExp("^-?\\d*\\.?\\d{0,"+this.decimalPlace+"}$", "g");
	    if (this.specialKeys.indexOf(event.key) !== -1) {
	      	return;
	    }
	    let current: string = this.el.nativeElement.value;
	    const position = this.el.nativeElement.selectionStart;
	    const next: string = [current.slice(0, position), event.key == 'Decimal' ? '.' : event.key, current.slice(position)].join('');
	    if (next && !String(next).match(regex)) {
	      	event.preventDefault();
	    }
  	}
}